import React from "react"
import { Grid } from "semantic-ui-react"
import { LoadingStatus } from "../LoadingFeedback"
import "./index.scss"

const SkeletonTile = () => (
	<div className="skeleton-tile">
		<div className="skeleton-gradient" />
		<div className="skeleton-text">
			<div className="skeleton-line title" />
			<div className="skeleton-line subtitle" />
		</div>
	</div>
)

// `label` is opt-in: with it the skeleton marks itself busy and announces the
// label to screen readers. Without it it renders exactly as it always has.
const LoadingSkeleton = ({ count = 8, columns = 4, label = null }) => {
	const skeletonIds = React.useMemo(() => Array.from({ length: count }, () => crypto.randomUUID()), [count])

	return (
		<>
			{/* A sibling of the busy block, not inside it, so the label is not held back. */}
			{label && <LoadingStatus message={label} />}
			<div className="LoadingSkeleton" aria-busy={label ? "true" : undefined}>
				<div className="skeleton-header" />
				<Grid>
					{skeletonIds.map(id => (
						<Grid.Column key={id} computer={columns} mobile={16}>
							<SkeletonTile />
						</Grid.Column>
					))}
				</Grid>
			</div>
		</>
	)
}

export default LoadingSkeleton
